/* AnimationDebugLogger – lightweight in‑memory logger for per‑frame animation tracing */

export type LogKind = 'event' | 'frame';

export interface AnimationLogEntry {
  t: number;            // performance timestamp (ms)
  sceneTime?: number;   // Phaser scene.time.now
  frame?: number;       // game loop frame count (approx)
  kind: LogKind;
  tag: string;          // short tag, e.g. PLAY_START, ADV_FRAME, PLAY_END
  data?: Record<string, unknown>;
}

export class AnimationDebugLogger {
  private static enabled = false;
  private static session = '';
  private static buffer: AnimationLogEntry[] = [];

  static start(session: string): void {
    this.session = session;
    this.buffer.length = 0;
    this.enabled = true;
    this.log('event', 'SESSION_START', { session });
  }

  static stop(): void {
    this.log('event', 'SESSION_STOP');
    this.enabled = false;
  }

  static isEnabled(): boolean { return this.enabled; }

  static log(kind: LogKind, tag: string, data?: Record<string, unknown>, timeCtx?: { sceneTime?: number; frame?: number }): void {
    if (!this.enabled) return;
    const entry: AnimationLogEntry = {
      t: (typeof performance !== 'undefined' ? performance.now() : Date.now()),
      sceneTime: timeCtx?.sceneTime,
      frame: timeCtx?.frame,
      kind,
      tag,
      data
    };
    this.buffer.push(entry);
  }

  static export(filename = 'animation-log.json'): void {
    const blob = new Blob([JSON.stringify({ session: this.session, entries: this.buffer }, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  }

  static getEntries(): AnimationLogEntry[] { return [...this.buffer]; }
}

export default AnimationDebugLogger;

